PF.ListCrud.Item.Select = class ItemSelect extends PF.Trait
	{
	initTrait()
		{
		super.initTrait();
		this.bindDom({selectInput: ['disabled'], selectCheckbox: 'show'}, 'list.selectMode');
		this.dom.selectInput.bindAll();
		this.connect('dom.selectInput.value', 'selectState');

		this.dom.item.on('fastClick@edit', () => this.trigger('startEdit'));
		this.dom.item.on('fastClick@select', () => {
			this.selectState = !this.selectState;
			this.list.selectMode = this.list.selected.length > 0;
		});

		this.onValue('list.selectMode', false, () => {
			this.dom.item.pauseEvent('fastClick@select');
			this.dom.item.resumeEvent('fastClick@edit');
		});
		this.onValue('list.selectMode', true, () => {
			this.dom.item.pauseEvent('fastClick@edit');
			this.dom.item.resumeEvent('fastClick@select');
		});

		this.dom.item.on('hold', () => {
			this.list.selectMode = !this.list.selectMode;
			this.selectState = true;
		});

		this.onValue('selectState', true, () => this.list.selected.push(this));
		this.onValue('selectState', false, () => {
			let index = this.list.selected.indexOf(this);
			this.list.selected.splice(index, 1);
		});

		this.model.on('delete-success', () => {
			this.selectState = false;
		});
		}
	};